
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSupportGoogle as ObiSupportGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-support-google.js';
 
 
 

 
 export const ObiSupportGoogle = createComponent({
   react: React,
   tagName: 'obi-support-google',
   elementClass: ObiSupportGoogleElement,
   events: {
     
   }
  });
 
 